export default __webpack_public_path__ + "static/media/IMG_20211220_213442.18de36a7.png";